import { Student, StudentAttendance, ApiResponse } from '@court-sync/shared';
import { apiGet, apiPost, apiPut, apiDelete } from './apiClient';

export const studentService = {
  async getStudents(academyId?: string): Promise<ApiResponse<Student[]>> {
    const params = academyId ? { academyId } : {};
    return apiGet<Student[]>('/students', { params });
  },

  async getStudent(id: string): Promise<ApiResponse<Student>> {
    return apiGet<Student>(`/students/${id}`);
  },

  async createStudent(studentData: {
    firstName: string;
    lastName: string;
    dateOfBirth: Date;
    gender: 'male' | 'female' | 'other';
    skillLevel?: 'beginner' | 'intermediate' | 'advanced';
    medicalNotes?: string;
    academyId?: string;
    isSelf?: boolean;
    emergencyContact?: {
      name: string;
      phone: string;
      relationship: string;
    };
  }): Promise<ApiResponse<{ id: string }>> {
    return apiPost<{ id: string }>('/students', studentData);
  },

  async updateStudent(id: string, studentData: {
    firstName: string;
    lastName: string;
    dateOfBirth: Date;
    gender: 'male' | 'female' | 'other';
    skillLevel?: 'beginner' | 'intermediate' | 'advanced';
    medicalNotes?: string;
    emergencyContact?: {
      name: string;
      phone: string;
      relationship: string;
    };
  }): Promise<ApiResponse<{ id: string }>> {
    return apiPut<{ id: string }>(`/students/${id}`, studentData);
  },

  async deleteStudent(id: string): Promise<ApiResponse<{ id: string }>> {
    return apiDelete<{ id: string }>(`/students/${id}`);
  },

  async getStudentAttendance(
    studentId: string,
    academyId?: string,
    scope?: { termId?: string; lessonId?: string }
  ): Promise<ApiResponse<StudentAttendance[]>> {
    const params: Record<string, string> = {};
    if (academyId) params.academyId = academyId;
    if (scope?.termId) params.termId = scope.termId;
    if (scope?.lessonId) params.lessonId = scope.lessonId;
    return apiGet<StudentAttendance[]>(`/students/${studentId}/attendance`, {
      params: Object.keys(params).length ? params : undefined,
    });
  },

  async getStudentAttendanceSummary(
    studentId: string,
    academyId?: string
  ): Promise<ApiResponse<{
    totalLessons: number;
    attendedLessons: number;
    missedLessons: number;
    cancelledLessons: number;
    attendanceRate: number;
    currentStreak: number;
    lastAttendedDate?: Date;
  }>> {
    return apiGet(`/students/${studentId}/attendance/summary`, academyId ? { params: { academyId } } : undefined);
  },
};
